import { useState, useEffect } from 'react';
import { useCheckTradingAgreement } from 'api/trading/useCheckTradingAgreement';

export const useTradingAgreement = () => {
    const [hasAgreement, setHasAgreement] = useState<boolean>(false);
    const { hasAgreement: apiHasAgreement, loading: apiLoading, refetch } = useCheckTradingAgreement();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkStatus = async () => {
            if (apiLoading) {
                setLoading(true);
                return;
            }

            try {
                // Check from FA Back API first
                const hasApiAgreement = apiHasAgreement;
                
                // Check localStorage as fallback/mock
                const hasLocalAgreement = localStorage.getItem('tradingAgreementCompleted') === 'true';
                
                // Use either API or localStorage (whichever is true)
                setHasAgreement(hasApiAgreement || hasLocalAgreement);
            } catch (error) {
                console.error('Failed to check trading agreement status:', error);
                // Fallback to localStorage
                const hasLocalAgreement = localStorage.getItem('tradingAgreementCompleted') === 'true';
                setHasAgreement(hasLocalAgreement);
            } finally {
                setLoading(false);
            }
        };
        
        checkStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiHasAgreement, apiLoading]);

    const checkAgreementStatus = () => {
        refetch();
    };

    const markAsCompleted = () => {
        setHasAgreement(true);
        // Refetch from API to get latest status
        refetch();
    };

    return {
        hasAgreement,
        loading,
        checkAgreementStatus,
        markAsCompleted,
    };
};
